import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { getConfig } from '@klpkonsern/appconfig';
import { useAppParams } from '@klp/core/app/useAppParams';
import { ActionButton, Block, Heading } from '@klp/design';
import { Paragraph } from '@klp/design/Typography/Typography/Paragraph';
import { generateRouteParams } from '@klp/routing';

import Image from '../assets/KLP_mann_datamaskin.png';

export interface ILevendeKontrakterParams {
    language: string;
    kundeNummer?: string;
    autologin: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    title: {
        fontFamily: theme.typography.fontFamily,
    },
    buttonsContainer: {
        display: 'flex',
    },
    image: {
        '& > img': {
            width: '70%',
            minHeight: '1px', // IE11 hack
            maxWidth: '70%',
        },
    },
    alertContainer: {
        backgroundColor: theme.palette.secondary.veryLight,
        border: '1px solid transparent',
        borderColor: theme.palette.secondary.main,
    },
    alertIcon: {
        width: '1em',
        height: '1em',
        fontSize: '2em',
    },
}));

export const LevendeKontrakter: React.FC = () => {
    const classes = useStyles();
    const { contractPath, selectedClient } = useAppParams();
    const { i18n } = useTranslation();

    const openLEKO = (destination: string) => () => {
        window.open(destination, 'Contracts');
    };

    const newTabParams: ILevendeKontrakterParams = {
        language: i18n.language,
        autologin: 'true',
    };

    if (selectedClient?.kundeNummer) {
        newTabParams.kundeNummer = selectedClient.kundeNummer;
    }

    const url = getConfig('WEBAPP_CONTRACT_FRAME_URL', '')
        .concat(contractPath || '')
        .concat(generateRouteParams(newTabParams));

    if (contractPath !== undefined) {
        window.location.href = url;
        return null;
    }

    return (
        <Grid container={true} direction="row" justifyContent="flex-start">
            <Grid item={true} md={true} lg={true}>
                <Heading
                    klpHeadingLevel="FOUR"
                    klpColor="dark"
                    translation="contractFrame.externalFrame.title"
                />
                <Block paddingTop="compact">
                    <Paragraph translation="contractFrame.externalFrame.description" />
                </Block>
                <Block paddingTop="compact">
                    <ActionButton
                        actionType="external"
                        translation="contractFrame.externalFrame.actionButton"
                        clickHandler={openLEKO(url)}
                    />
                </Block>
            </Grid>
            <Grid item={true} md={12} lg={6}>
                <Block className={classes.image} paddingTop="fat">
                    <img src={Image} alt="KLP Mann Datamaskin" />
                </Block>
            </Grid>
        </Grid>
    );
};
